export default "__VITE_ASSET__D$DMEx6d__"